<template>
  <div>
    <NavBar />
    <div class="container">
      <v-btn class="v-primary mb-2" @click="$router.go(-1)">
        <span class="fa fa-arrow-left"></span> Voltar
      </v-btn>
      <vs-card>
        <WarningRequiredFields />
        <ErrorsMessages :errors="errors" />
        <b-overlay :show="loading" opacity="0.99">
          <form v-on:submit="update" method="post">
            <div class="row">
              <div class="col-md-12">
                <LabelRequiredField label="Nome" />
                <input
                  :disabled="!permissions.admin.edit"
                  type="text"
                  v-model="name"
                  class="form-control"
                />
              </div>
              <div class="col-md-6">
                <LabelRequiredField label="E-Mail" />
                <input
                  :disabled="!permissions.admin.edit"
                  type="email"
                  v-model="email"
                  class="form-control"
                />
              </div>
              <div class="col-md-6">
                <LabelRequiredField label="Perfil" />
                <select
                  :disabled="!permissions.admin.edit"
                  v-model="profile_id"
                  class="form-control"
                >
                  <option
                    v-for="profile in profiles"
                    :key="profile.id"
                    :value="profile.id"
                  >
                    {{ profile.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <LabelRequiredField label="Status" />
                <select
                  :disabled="!permissions.admin.edit"
                  v-model="status"
                  class="form-control"
                >
                  <option value="1">Ativo</option>
                  <option value="0">Inativo</option>
                </select>
              </div>
              <div class="col-md-12">
                <h6>
                  <span class="text-muted">Criação:</span>
                  {{ formatDate(created_at) }}
                </h6>
                <h6>
                  <span class="text-muted">Última alteração:</span>
                  {{ formatDate(updated_at) }}
                </h6>
              </div>
              <div class="col-md-12 text-right">
                <v-btn
                  v-if="permissions.admin.edit"
                  type="button"
                  class="v-secondary mr-1"
                  v-on:click="handleModalChangePassword()"
                >
                  <span class="fa fa-edit"></span> Alterar senha
                </v-btn>
                <v-btn
                  v-if="permissions.admin.edit"
                  :disabled="loadingUpdate"
                  type="submit"
                  class="v-success"
                >
                  <span class="fa fa-check"></span>
                  {{ loadingUpdate ? "Carregando" : "Salvar" }}
                </v-btn>
              </div>
            </div>
          </form>
        </b-overlay>
        <hr />
        <h4 class="text-center">Permissões</h4>
        <b-overlay :show="loadingPermissions" opacity="0.99">
          <div class="text-center" v-if="allPermissions.length == 0">
            <span>Não foram definido acessos para o perfil do usuário!!!</span>
            <br />
            <vs-button
              @click="handleToPermissions"
              class="v-secondary"
              type="relief"
              >Adicionar</vs-button
            >
          </div>
          <v-data-table
            dense
            :headers="[
              { text: 'Nome', value: 'name' },
              {
                text: 'CADASTRAR',
                value: 'writers',
              },
              {
                text: 'VISUALIZAR',
                value: 'readers',
              },
              {
                text: 'EDITAR',
                value: 'editors',
              },
              {
                text: 'REMOVER',
                value: 'removers',
              },
            ]"
            :items="allPermissions"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleGoToPermission"
          >
            <template v-slot:[`item.writers`]="{ item }">
              <i v-if="item.writers" class="fa fa-check c-success"></i>
              <i v-else class="fa fa-close c-danger"></i>
            </template>
            <template v-slot:[`item.readers`]="{ item }"
              ><i v-if="item.readers" class="fa fa-check c-success"></i>
              <i v-else class="fa fa-close c-danger"></i>
            </template>
            <template v-slot:[`item.editors`]="{ item }">
              <i v-if="item.editors" class="fa fa-check c-success"></i>
              <i v-else class="fa fa-close c-danger"></i
            ></template>
            <template v-slot:[`item.removers`]="{ item }">
              <i v-if="item.removers" class="fa fa-check c-success"></i>
              <i v-else class="fa fa-close c-danger"></i
            ></template>
          </v-data-table>
        </b-overlay>
      </vs-card>
      <!-- Modal change password -->
      <b-modal id="modalChangePassword" hide-footer>
        <template v-slot:modal-title>Alterar senha</template>
        <div class="d-block">
          <div class="container">
            <form v-on:submit="updatePassword" method="post">
              <div class="row">
                <WarningRequiredFields />
                <ErrorsMessages :errors="errors" />
                <div class="col-md-12">
                  <LabelRequiredField label="Senha" />
                  <input
                    type="password"
                    v-model="password"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
                <div class="col-md-12">
                  <LabelRequiredField label="Confirma senha" />
                  <input
                    type="password"
                    v-model="confirm_password"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
                <div class="col-md-12 text-right">
                  <v-btn
                    :disabled="loadingUpdatePassword"
                    type="submit"
                    class="v-success"
                  >
                    <span class="fa fa-check"></span>
                    {{ loadingUpdatePassword ? "Carregando" : "Salvar" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-modal>
      <!-- /Modal change password -->
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import { formatDate } from "../functions/format";
import toast from "../components/ToastNotification";
import api from "../services/api";
import routes from "../routes";
import { adminData } from "../lib/functions";

export default {
  name: "Admin",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      profiles: [],
      id: "",
      profile_id: "",
      name: "",
      email: "",
      status: "",
      password: "",
      confirm_password: "",
      created_at: "",
      updated_at: "",
      loadingUpdate: false,
      loadingUpdatePassword: false,
      loading: true,
      loadingPermissions: true,
      allPermissions: [],
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.retrieve();
  },
  methods: {
    formatDate,
    async retrieve() {
      const { id } = routes.history.current.params;

      this.id = id;

      await this.get();
      await this.getProfiles();
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        const response = await api.get("/admin/get", {
          params: { id },
        });

        const { admin, error } = response.data;

        if (error) {
          return routes.push({ name: "admins" });
        }

        this.profile_id = admin.profile_id;
        this.name = admin.name;
        this.email = admin.email;
        this.status = admin.status;
        this.created_at = admin.created_at;
        this.updated_at = admin.updated_at;

        await this.getPermissions();

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getProfiles() {
      const response = await api.get("/admin/profile/all");

      const { profiles } = response.data;

      this.profiles = profiles;
    },
    async getPermissions() {
      try {
        this.loadingPermissions = true;

        const { profile_id: id } = this;

        const response = await api.get("/admin/profile/permissions/all", {
          params: { id },
        });

        const { permissions } = response.data;

        var array = [];

        for (const item of permissions) {
          if (item.writers || item.readers || item.editors || item.removers) {
            array.push(item);
          }
        }

        this.allPermissions = array;

        this.loadingPermissions = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name, email, status, profile_id } = this;

        let params = {
          id,
          name,
          email,
          status,
          profile_id,
        };

        const response = await api.put("/admin/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async updatePassword(event) {
      try {
        event.preventDefault();

        this.loadingUpdatePassword = true;

        const { id, password, confirm_password } = this;

        let params = {
          id,
          password,
          confirm_password,
        };

        const response = await api.put("/admin/password/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("modalChangePassword");
          this.password = "";
          this.confirm_password = "";
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }

        this.loadingUpdatePassword = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalChangePassword() {
      this.errors = [];
      this.$bvModal.show("modalChangePassword");
    },
    handleToPermissions: () => routes.push({ name: "permissions" }),
    handleGoToPermission: ({ id }) =>
      routes.push({
        name: "permission",
        params: {
          id,
        },
      }),
  },
};
</script>